import React from 'react';
import createReactClass from 'create-react-class';
import AutocompleteText from '../AutocompleteText';
import Formsy from 'formsy-react';
import { ComponentMixin, Row } from 'formsy-react-components';

var FormsySelect = createReactClass({

  // Add the Formsy Mixin
  mixins: [Formsy.Mixin, ComponentMixin],

  previousSelection: {
    id: null,
    name: null
  },

  getDefaultProps() {
    return {
      selection: {
        id: null,
        name: null
      }
    };
  },

  // setValue() will set the value of the component, which in
  // turn will validate it and the rest of the form
  changeValue(selection) {
    this.setValue(selection.id);
  },

  componentDidMount() {
    if(this.props.selection && this.props.selection.id !== null) {
      this.autoComplete.setSelection(this.props.selection);
    }
  },

  componentWillReceiveProps({selection}) {
    if(this.props.selection.id !== selection.id) {
      this.autoComplete.setSelection(selection);
    }
  },

  render() {

    if (this.getLayout() === 'elementOnly') {
      return this.renderElement();
    }

    return (
        <Row
            {...this.getRowProperties()}
            htmlFor={this.getId()}
        >
            {this.renderElement()}
            {this.renderHelp()}
            {this.renderErrorMessage()}
        </Row>
    );
  },

  renderElement() {
    return (
        <AutocompleteText
          {...this.props}
          ref={c => this.autoComplete = c}
          onSelect={this.changeValue}
        />
    );
  }
});

export default FormsySelect;



// WEBPACK FOOTER //
// ./src/components/common/Forms/FormsySelect.js